/*
  Intercambio de formato dentro de una tarjeta de grilla (búsqueda / colección).

  Las píldoras las arma Liquid (snippets/formato-pill.liquid) con TODOS los
  valores ya calculados en data-attributes: precio del usuario que corresponda
  (empleado / catador / público), precio por litro, imagen, variante y stock.
  Este archivo solo intercambia esos valores en el DOM: no replica la lógica de
  precios ni la expone al navegador.

  Se usa delegación de eventos para que también funcione en las grillas que se
  re-renderizan por filtros o por el Theme Editor.
*/
(function () {
  'use strict';

  var CARD = '.collection-product-card';

  function money(cents) {
    // theme.js ya define el formato de la tienda; acá solo se reutiliza
    if (typeof window.formatPrice === 'function') return window.formatPrice(cents);
    return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function num(pill, attr) {
    var raw = pill.getAttribute(attr);
    if (raw === null || raw === '') return NaN;
    return parseInt(raw, 10);
  }

  // Muestra el nodo con el texto dado; lo oculta si el texto viene vacío
  function setText(node, text) {
    if (!node) return;
    if (text) {
      node.textContent = text;
      node.style.display = '';
    } else {
      node.textContent = '';
      node.style.display = 'none';
    }
  }

  function actualizarPrecios(card, precio, comparar) {
    var cur = card.querySelector('.collection-price-current');
    if (cur && !isNaN(precio)) {
      cur.setAttribute('data-price', precio);
      cur.textContent = money(precio);
    }

    var wrap = card.querySelector('.collection-prices');
    var cmp = card.querySelector('.collection-price-compare');
    var hayDescuento = !isNaN(comparar) && comparar > precio;

    if (hayDescuento && !cmp && wrap) {
      // La tarjeta arrancó sin precio tachado porque su formato no tenía oferta
      cmp = document.createElement('span');
      cmp.className = 'collection-price-compare';
      wrap.insertBefore(cmp, wrap.firstChild);
    }
    if (cmp) {
      if (hayDescuento) {
        cmp.setAttribute('data-price', comparar);
        cmp.textContent = money(comparar);
        cmp.style.display = '';
      } else {
        cmp.removeAttribute('data-price');
        cmp.textContent = '';
        cmp.style.display = 'none';
      }
    }

    actualizarBadgeDescuento(card, precio, comparar, hayDescuento);
  }

  function actualizarBadgeDescuento(card, precio, comparar, hayDescuento) {
    var cont = card.querySelector('.collection-card-image');
    var badge = card.querySelector('.product-badge');
    if (!hayDescuento) {
      if (badge) badge.style.display = 'none';
      return;
    }
    if (!badge && cont) {
      badge = document.createElement('div');
      badge.className = 'product-badge';
      badge.appendChild(document.createElement('span'));
      badge.appendChild(document.createElement('span'));
      cont.appendChild(badge);
    }
    if (!badge) return;
    var pct = Math.round((comparar - precio) * 100 / comparar);
    var spans = badge.querySelectorAll('span');
    if (spans.length >= 2) {
      spans[0].textContent = pct + '%';
      spans[1].textContent = 'OFF';
    }
    badge.style.display = '';
  }

  function actualizarPorLitro(card, valor) {
    var ppl = card.querySelector('.collection-price-per-liter');
    if (!valor) {
      if (ppl) {
        ppl.removeAttribute('data-price-per-liter');
        ppl.textContent = '';
        ppl.style.display = 'none';
      }
      return;
    }
    if (!ppl) {
      // El formato anterior podía no tener datos para calcularlo
      var wrap = card.querySelector('.collection-prices');
      if (!wrap || !wrap.parentNode) return;
      ppl = document.createElement('p');
      ppl.className = 'collection-price-per-liter';
      wrap.parentNode.insertBefore(ppl, wrap.nextSibling);
    }
    ppl.setAttribute('data-price-per-liter', valor);
    ppl.textContent = '(' + money(parseFloat(valor)) + ' por litro)';
    ppl.style.display = '';
  }

  function actualizarTextos(card, pill) {
    var link = card.querySelector('.collection-product-title a');
    var url = pill.getAttribute('data-url');
    if (link) {
      var titulo = pill.getAttribute('data-title');
      if (titulo) {
        link.textContent = titulo;
        // El titulo se recorta a dos lineas en mobile: el completo vive aca
        link.setAttribute('title', titulo);
      }
      if (url) link.setAttribute('href', url);
    }

    var units = card.querySelector('.collection-units');
    var unitsText = pill.getAttribute('data-units-text');
    if (!units && unitsText) {
      var info = card.querySelector('.collection-card-info');
      var titulo = card.querySelector('.collection-product-title');
      if (info && titulo) {
        units = document.createElement('p');
        units.className = 'collection-units';
        info.insertBefore(units, titulo.nextSibling);
      }
    }
    setText(units, unitsText);

    var badge = card.querySelector('.product-label-badge');
    var badgeText = pill.getAttribute('data-badge-text');
    if (!badge && badgeText) {
      // La tarjeta arranco sin etiqueta porque su formato no tenia badge_label
      // ni bottle_format; el hermano si, asi que hay que crear el nodo.
      var contImg = card.querySelector('.collection-card-image');
      if (contImg) {
        badge = document.createElement('div');
        badge.className = 'product-label-badge';
        contImg.appendChild(badge);
      }
    }
    setText(badge, badgeText);
  }

  function actualizarImagen(card, pill) {
    var src = pill.getAttribute('data-image');
    var img = card.querySelector('.collection-card-image img');
    if (img && src) img.src = src;

    var url = pill.getAttribute('data-url');
    var enlaceImg = card.querySelector('.collection-card-image a');
    if (enlaceImg && url) enlaceImg.setAttribute('href', url);
  }

  function actualizarBoton(card, pill) {
    var btn = card.querySelector('.collection-add-btn');
    if (!btn) return;
    var variante = pill.getAttribute('data-variant-id');
    if (variante) btn.setAttribute('data-variant-id', variante);

    var disponible = pill.getAttribute('data-available') === 'true';
    btn.disabled = !disponible;
    btn.textContent = disponible ? 'AGREGAR AL CARRITO' : 'AGOTADO';
  }

  function activar(pill) {
    var card = pill.closest(CARD);
    var grid = pill.closest('[data-formato-grid]');
    if (!card || !grid) return;

    var hermanas = grid.querySelectorAll('.formato-pill');
    for (var i = 0; i < hermanas.length; i++) {
      hermanas[i].classList.remove('is-active');
      hermanas[i].removeAttribute('aria-current');
    }
    pill.classList.add('is-active');
    pill.setAttribute('aria-current', 'true');

    actualizarPrecios(card, num(pill, 'data-precio'), num(pill, 'data-comparar'));
    actualizarPorLitro(card, pill.getAttribute('data-ppl'));
    actualizarTextos(card, pill);
    actualizarImagen(card, pill);
    actualizarBoton(card, pill);
  }

  /*
    Los filtros del sidebar (formato:, cepa:, valle:) y sus contadores leen el
    data-tags de la tarjeta, que trae solo los tags del hermano visible. Sin
    esto, filtrar por "Pack" escondia al grupo aunque el pack estuviera
    disponible en sus pildoras, y la opcion se auto-ocultaba por contador 0.
    Se fusionan los tags de todos los hermanos en la tarjeta.
  */
  function fusionarTags(card) {
    if (card.hasAttribute('data-formato-tags-fusionados')) return;
    var grid = card.querySelector('[data-formato-grid]');
    if (!grid) return;
    card.setAttribute('data-formato-tags-fusionados', 'true');

    var acumulados = [];
    var vistos = {};
    function agregar(lista) {
      for (var i = 0; i < lista.length; i++) {
        var t = lista[i];
        if (!t || vistos[t]) continue;
        vistos[t] = true;
        acumulados.push(t);
      }
    }

    agregar((card.getAttribute('data-tags') || '').split('|||'));
    var pills = grid.querySelectorAll('.formato-pill');
    for (var i = 0; i < pills.length; i++) {
      agregar((pills[i].getAttribute('data-tags') || '').split('|||'));
    }
    card.setAttribute('data-tags', acumulados.join('|||'));
  }

  // Palabras iniciales que comparten dos titulos
  function prefijoComun(a, b) {
    var pa = (a || '').split(' ');
    var pb = (b || '').split(' ');
    var n = 0;
    while (n < pa.length && n < pb.length && pa[n] === pb[n]) n++;
    return n;
  }

  /*
    La tarjeta la arma Liquid con el primer hermano que aparece en la
    coleccion, que casi siempre es el x1. Se activa el pack mas grande
    disponible (x6, x12). Si hay varios packs del mismo tamano (variedades
    distintas: Gres x3 / Granito x3), gana el que mas se parece al vino de la
    tarjeta, para no cambiarle el vino al cliente.
  */
  function preseleccionarMayor(card) {
    if (card.hasAttribute('data-formato-preseleccion')) return;
    var grid = card.querySelector('[data-formato-grid]');
    if (!grid) return;
    card.setAttribute('data-formato-preseleccion', 'true');

    var actual = grid.querySelector('.formato-pill.is-active');
    var pills = grid.querySelectorAll('.formato-pill');
    var packsActual = actual ? num(actual, 'data-packs') || 1 : 1;
    var tituloActual = actual ? actual.getAttribute('data-title') : '';

    var mejor = null;
    var mejorPacks = packsActual;
    var mejorParecido = -1;
    for (var i = 0; i < pills.length; i++) {
      var p = pills[i];
      if (p === actual || p.getAttribute('data-available') !== 'true') continue;
      var packs = num(p, 'data-packs') || 1;
      if (packs < mejorPacks) continue;
      var parecido = prefijoComun(tituloActual, p.getAttribute('data-title'));
      if (packs > mejorPacks || parecido > mejorParecido) {
        mejor = p;
        mejorPacks = packs;
        mejorParecido = parecido;
      }
    }
    // Con empate de packs contra el actual, el actual se queda
    if (mejor && mejorPacks > packsActual) activar(mejor);
  }

  // La llama tambien collection.liquid con las tarjetas que trae por AJAX
  window.catadoresFormatoSync = function (scope) {
    var raiz = scope || document;
    var cards = raiz.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) {
      fusionarTags(cards[i]);
      preseleccionarMayor(cards[i]);
    }
  };

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var pill = e.target.closest('[data-formato-grid] .formato-pill');
    if (!pill) return;
    e.preventDefault();
    activar(pill);
  });

  /*
    El script va con defer: se ejecuta con el DOM ya parseado y ANTES de
    DOMContentLoaded, que es cuando collection.liquid corre updateFilterCounts().
    Asi los contadores del sidebar ya ven los tags fusionados.
  */
  window.catadoresFormatoSync(document);
})();
